import { render, staticRenderFns } from "./NewDiligencia.vue?vue&type=template&id=1f53d8cc"
import script from "./NewDiligencia.vue?vue&type=script&lang=js"
export * from "./NewDiligencia.vue?vue&type=script&lang=js"
import style0 from "./NewDiligencia.vue?vue&type=style&index=0&id=1f53d8cc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports